import RegisterAgent from './RegisterAgent';

export default RegisterAgent;